import { Injectable } from '@angular/core';
import { BaseApi } from '../../base-api.service';
import { Observable, of } from 'rxjs';
import { ApplicantService } from '../../applicant.service';
import { map } from 'rxjs/operators';


@Injectable()
export class CibilReportService {

  private applicantId: string;
  private baseUrl = '/users';
  private getBaseUrl = "";
  constructor(
    private api: BaseApi,
    private applicant: ApplicantService,
  ) {
    this.applicantId = applicant.getApplicantID(),
      this.getBaseUrl = `/applicants/${this.applicantId}/assets/bhoomi`;
  }

  private crifFaxIds = [
    { id: 1, name: 'Aadhaar Card' },
    { id: 2, name: 'PAN' },
    { id: 3, name: 'Driving Licence' },
    // { id: 4, name: 'Passport' },
    { id: 4, name: 'Ration Card' },
    { id: 5, name: 'Voter ID' },
  ];

  private district = [
    { id: 2, name: 'Bagalkot' },
    { id: 12, name: 'Ballari' },
    { id: 21, name: 'Bangalore Rural' },
    { id: 1, name: 'Belagavi' },
    { id: 20, name: 'Bengaluru Urban' },
    { id: 5, name: 'Bidar' },
    { id: 27, name: 'Chamarajanagara' },
    { id: 28, name: 'Chikkaballapur' },
    { id: 17, name: 'Chikkamagaluru' },
    { id: 13, name: 'Chitradurga' },
    { id: 24, name: 'Dakshina Kannada' },
    { id: 14, name: 'Davanagere' },
    { id: 9, name: 'Dharwad' },
    { id: 8, name: 'Gadag' },
    { id: 23, name: 'Hassan' },
    { id: 11, name: 'Haveri' },
    { id: 4, name: 'Kalaburagi' },
    { id: 25, name: 'Kodagu' },
    { id: 19, name: 'Kolar' },
    { id: 7, name: 'Koppal' },
    { id: 22, name: 'Mandya' },
    { id: 26, name: 'Mysuru' },
    { id: 6, name: 'Raichur' },
    { id: 29, name: 'Ramanagara' },
    { id: 15, name: 'Shivamogga' },
    { id: 18, name: 'Tumakuru' },
    { id: 16, name: 'Udupi' },
    { id: 10, name: 'Uttar Kannada' },
    { id: 3, name: 'Vijayapura' },
    { id: 30, name: 'Yadagir' },
  ]

  private taluk = [
    { id: 1, name: 'Tumkur' },
    { id: 2, name: 'Sira' },
  ]

  private hobli = [
    { id: 1, name: 'Tumkur' },
    { id: 2, name: 'Yallapura' },
  ]

  private village = [
    { id: 1, name: 'Oorukere' },
    { id: 2, name: 'Yallapura' },
  ]

  private surnoc = [
    { id: 1, name: '*' },
    { id: 2, name: '/' },
  ]

  private hissa = [
    { id: 1, name: '1a' },
    { id: 2, name: '1b' },
  ]

  private period = [
    { id: 1, name: '2001-12-13 00:00:00 To Till Date (2019-2020 )' },
    { id: 2, name: '2001-12-13 00:00:00 To Till Date (2018-2019 )' },
    { id: 3, name: '2001-12-13 00:00:00 To Till Date (2017-2018 )' },
    { id: 4, name: '2001-12-13 00:00:00 To Till Date (2016-2017 )' },
    { id: 5, name: '2001-12-13 00:00:00 To Till Date (2015-2016 )' },
  ]

  private relations = [
    { id: 1, name: 'Partner' },
    { id: 2, name: 'Director' },
    { id: 3, name: 'Husband' },
    { id: 4, name: 'Wife' },
    { id: 5, name: 'Father' },
    { id: 6, name: 'Mother' },
    { id: 7, name: 'Son' },
    { id: 8, name: 'Brother' },
    { id: 9, name: 'Sister' },
    { id: 10, name: 'Other' },
  ];

  private category = [
    { id: 1, name: 'Health Care' },
    { id: 2, name: 'Non-Health Care/ PLM' },
  ];

  private subcategory = [
    { id: 1, name: 'Individual' },
    { id: 2, name: 'Proprietary' },
    { id: 3, name: 'Partnership' },
    { id: 4, name: 'LLP' },
    { id: 5, name: 'Private Limited' },
  ];

  private state = [
    { id: 'AP', name: 'Andhra Pradesh' },
    { id: 'AR', name: 'Arunachal Pradesh' },
    { id: 'AS', name: 'Assam' },
    { id: 'BR', name: 'Bihar' },
    { id: 'CG', name: 'Chattisgarh' },
    { id: 'GA', name: 'Goa' },
    { id: 'GJ', name: 'Gujarat' },
    { id: 'HR', name: 'Haryana' },
    { id: 'HP', name: 'Himachal Pradesh' },
    { id: 'JK', name: 'Jammu & Kashmir' },
    { id: 'JH', name: 'Jharkhand' },
    { id: 'KA', name: 'Karnataka' },
    { id: 'KL', name: 'Kerala' },
    { id: 'MP', name: 'Madhya Pradesh' },
    { id: 'MH', name: 'Maharashtra' },
    { id: 'MN', name: 'Manipur' },
    { id: 'ML', name: 'Meghalaya' },
    { id: 'MZ', name: 'Mizoram' },
    { id: 'NL', name: 'Nagaland' },
    { id: 'OR', name: 'Orissa' },
    { id: 'PB', name: 'Punjab' },
    { id: 'RJ', name: 'Rajasthan' },
    { id: 'SK', name: 'Sikkim' },
    { id: 'TN', name: 'Tamil Nadu' },
    { id: 'TS', name: 'Telangana' },
    { id: 'TR', name: 'Tripura' },
    { id: 'UK', name: 'Uttarakhand' },
    { id: 'UP', name: 'Uttar Pradesh' },
    { id: 'WB', name: 'West Bengal' },
    { id: 'AN', name: 'Andaman & Nicobar' },
    { id: 'CH', name: 'Chandigarh' },
    { id: 'DN', name: 'Dadra and Nagar Haveli' },
    { id: 'DD', name: 'Daman & Diu' },
    { id: 'DL', name: 'Delhi' },
    { id: 'LD', name: 'Lakshadweep' },
    { id: 'PY', name: 'Pondicherry' },
  ];

  private loan = [
    { id: 6, name: 'Loan Against Cards / Deposits / Receipts / Receivables' },
    { id: 100, name: 'Cash Credit' },
    { id: 200, name: 'Overdraft' },
    { id: 500, name: 'packing credit' },
    { id: 630, name: 'Export Bills - Discounted / Purchased / Advanced Against' },
    { id: 640, name: 'Equipment Loans/ Term Loans' },
    { id: 710, name: 'Inland Bills - Discounted / Purchased' },
    { id: 800, name: 'Advances Against Export Cash Incentives / Import Bills' },
    { id: 801, name: 'working capital loans' },
    { id: 900, name: 'Foreign Currency Cheques / Dd\'s / Tc\'s' },
    { id: 1100, name: 'Hire Purchase / Lease' },
    { id: 2000, name: 'Bank Guarantee' },
    { id: 3000, name: 'Letters Of Credit' },
    { id: 4000, name: 'Commercial Vehicle Loan' },
    { id: 9999, name: 'Others' },
  ];

  private entity = [
    { id: '54', name: 'Director' },
    { id: '07', name: 'Executive Director' },
    { id: '53', name: 'Independent Director' },
    { id: '52', name: 'Nominee Director' },
    { id: '60', name: 'Other' },
    { id: '30', name: 'Partner' },
    { id: '01', name: 'Promoter' },
    { id: '51', name: 'Promoter Director' },
    { id: '20', name: 'Proprietor' },
    { id: '10', name: 'Shareholder' },
    { id: '40', name: 'Trustee' }
  ];

  private organization = [
    { id: '01', name: 'Subsidiary Company' },
    { id: '02', name: 'Holding Company' },
    { id: '03', name: 'Group Company' },
    { id: '04', name: 'Standalone Company' },
    { id: '05', name: 'Shareholder' },
    { id: '06', name: 'Other' }

  ]

  private activity = [
    { id: 'AGRICULTURE AND FORESTRY', name: 'AGRICULTURE AND FORESTRY' },
    { id: 'CONSTRUCTION', name: 'CONSTRUCTION' },
    { id: 'EDUCATION', name: 'EDUCATION' },
    { id: 'ELECTRICITY, GAS AND WATER SUPPLY', name: 'ELECTRICITY, GAS AND WATER SUPPLY' },
    { id: 'FINANCIAL INTERMEDIATION', name: 'FINANCIAL INTERMEDIATION' },
    { id: 'FISHING', name: 'FISHING' },
    { id: 'HEALTH AND SOCIAL WORK', name: 'HEALTH AND SOCIAL WORK' },
    { id: 'HOTELS AND RESTAURANTS', name: 'HOTELS AND RESTAURANTS' },
    { id: 'MANUFACTURING', name: 'MANUFACTURING' },
    { id: 'MINING AND QUARRYING', name: 'MINING AND QUARRYING' },
    { id: 'OTHER COMMUNITY, SOCIAL AND PERSONAL SERVICE ACTIVITIES', name: 'OTHER COMMUNITY, SOCIAL AND PERSONAL SERVICE ACTIVITIES' },
    { id: 'PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY', name: 'PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY' },
    { id: 'REAL ESTATE, RENTING AND BUSINESS ACTIVITIES', name: 'REAL ESTATE, RENTING AND BUSINESS ACTIVITIES' },
    { id: 'TRANSPORT, STORAGE AND COMMUNICATIONS', name: 'TRANSPORT, STORAGE AND COMMUNICATIONS' },
    { id: 'WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES, MOTORCYCLES AND PERSONAL / HOUSEHOLD GOODS', name: 'WHOLESALE AND RETAIL TRADE; REPAIR OF MOTOR VEHICLES, MOTORCYCLES AND PERSONAL / HOUSEHOLD GOODS' },



  ]

  updateSegmentCustType(data) {
    return this.api.postRes(`/users/updateSegment`, data).pipe(map(res => {
      return res;
    }))
  }

  addCustomer(admin) {
    return this.api.postRes(`/users/regLead`, admin).pipe(map(res => {
      return res;
    }))
  }

  getCibilData() {
    return this.api.postRes(`/score/getcreditdata`, {appId:this.applicantId, type:1 }).pipe(map(res => {
      return res;
    }))
  }

  getCreditDoc() {
    return this.api.postRes('/users/getCreditReportPDF', {appId:this.applicantId})
    .pipe(map(res => {
      return res;
    }));
  }

  getCibilReportManually(data){
    let dataToSend = data
    data.appId = this.applicantId
    return this.api.postRes(`/score/generatecreditreport`, data).pipe(map(res => {
      return res;
    }))
  }

  get() {
    return this.api.newGet(this.getBaseUrl);
  }

  getConsent(){
    return this.api.getComplt(`/users/getConsent/${this.applicantId}`);
  }

  getPin(args){
    return this.api.getComplt(`/users/getAddress/${args}`);
  }

  crif(data){
    data.appId = this.applicantId;
    return this.api.postRes('/score/initiate', data).pipe(map(resp => {
      console.log("Crif resp service " + JSON.stringify(resp));
      return resp;
    }))
  }

  crifRep(data){
    data.appId = this.applicantId;
    return this.api.postRes('/score/userAuthentication', data).pipe(map(resp => {
      console.log("Crif report " + JSON.stringify(resp));
      return resp;
    }))
  }

  getCrif(){
    return this.api.getComplt(`/score/getCrifData/${this.applicantId}`);
  }

  getData(){
    return this.api.getComplt(`/applicants/${this.applicantId}`);
  }

  getcrifFaxIds(){
    return of(this.crifFaxIds);
  }

//   login() {
//     var data = {
//       appId: this.applicantId
//     }
//     return this.api.postResp('/loans/login', data).map(resp => {
//       console.log("resp in service " + JSON.stringify(resp));
//       return resp;
//     })
//   }

  getCoAppCount(custId) {
    return this.api.postRes('/users/getCoAppCount', { custId: custId }).pipe(map(resp => {
      console.log("resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }

  getDistrict() {
    return of(this.district)
  }

  getTaluk() {
    return of(this.taluk)
  }

  // getHobli(){
  //   return of(this.hobli)
  // }



  // getSurnoc(){
  //   return of(this.surnoc)
  // }


  getRelations() {
    return of(this.relations);
  }

  getCat() {
    return of(this.category);
  }

  getSubCat() {
    return of(this.subcategory);
  }

  getAppCount() {
    return this.api.postRes('/users/getAppCount', "").pipe(map(resp => {
      console.log("resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }

  getGuarantorCount(custId) {
    return this.api.postRes('/users/getGuarantorCount', { custId: custId }).pipe(map(resp => {
      console.log("resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }

  getGroupManagers() {
    return this.api.newGet(`${this.baseUrl}/getGroupSalesManagers`);
  }

  getCrifState() {
    return of(this.state);
  }

  getCrifLoan() {
    return of(this.loan);
  }

  getCrifEntity() {
    return of(this.entity);
  }

  getCrifOrganization() {
    return of(this.organization);
  }

  getActivity() {
    return of(this.activity);
  }
  
  getBreStatus(){
    return this.api.newGetTemp(`/users/getBreStatus?applicantId=${this.applicantId}`);
  }

  getBreStatusAP(){
    return this.api.newGetTemp(`/users/getBreStatus?applicantId=${this.applicantId}`);
  }

}
